export class User {
	given_name: string;
	family_name: string;
	userAccessDetails?: UserAccessDetail[];
	emails: string[];
	uuid: string;
}

export class UserAccessDetail {
	product_code: string;
	platform_code: string;
	participant_id: number;
	participant_role: string;
	extension_role: string;
}
